import { render, staticRenderFns } from "./DetalhesImpedimento.vue?vue&type=template&id=4372e434"
import script from "./DetalhesImpedimento.vue?vue&type=script&lang=ts"
export * from "./DetalhesImpedimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports